import { IDealSourceData } from 'modules/core/types/dealSource';

import { getSubmitRouteOneLenderId } from '../../utils/submitRouteOneLenderId.utils';

export interface IExtractedDealSourceParams {
  conversation_id?: string;
  dealer_id?: string;
  r1_lender_id?: string;
}

export const extractDealSourceParams = (
  dealSourceData: IDealSourceData | undefined,
  selectedLenderRouteOneId?: string | null,
): IExtractedDealSourceParams => {
  const params: IExtractedDealSourceParams = {};

  if (dealSourceData?.conversation_id) {
    params.conversation_id = dealSourceData.conversation_id;
  }

  if (dealSourceData?.dealer_id) {
    params.dealer_id = dealSourceData.dealer_id;
  }

  const r1LenderId = getSubmitRouteOneLenderId(selectedLenderRouteOneId, dealSourceData?.lender);

  if (r1LenderId) {
    params.r1_lender_id = r1LenderId;
  }

  return params;
};
